import React from "react";
import PropTypes from "prop-types";
import CustomModal from "../CustomModal";
import CustomButton from "../CustomButton";
import { NDPA_CONSENT_TEXT } from "../../utils/growNetwork";

const NdpaConsentModal = ({ isOpen, onClose, onConsent, loading }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Contact Import Consent"
      maxWidth="520px"
    >
      <p className="gn-consent-text">{NDPA_CONSENT_TEXT}</p>
      <div className="d-flex justify-content-end">
        <CustomButton
          text="Cancel"
          backgroundColor="#fff"
          color="#64748B"
          borderColor="#CBD5E1"
          handleClick={onClose}
          additionalClass="mr-2"
        />
        <CustomButton
          text={loading ? "Saving..." : "I Consent — Continue"}
          backgroundColor="#3A6ED4"
          color="#fff"
          handleClick={onConsent}
          disabled={loading}
        />
      </div>
    </CustomModal>
  );
};

NdpaConsentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConsent: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default NdpaConsentModal;
